import { useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useAppSelector } from '../app/hooks';
import { selectIsLoggedIn } from '../selectors/user';
import { selectIdleLogOutTime } from '../redux/features/config/config.selector';

const IDEAL_TIME_OUT_MESSAGE = 'Session Timeout, Please re login';

const useAppIdleTimer = ({ logout }: { logout: Function }) => {
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const IDLE_LOGOUT_TIME = useAppSelector(selectIdleLogOutTime);
  const onIdle = () => logout(IDEAL_TIME_OUT_MESSAGE);
  const { start, pause } = useIdleTimer({
    timeout: IDLE_LOGOUT_TIME,
    onIdle,
    startManually: true,
  });

  useEffect(() => {
    if (isLoggedIn) start();
    else pause();
  }, [isLoggedIn]);
};

export default useAppIdleTimer;
